import { cn } from "@/lib/utils";

const DotButtons = ({
  navigationButtonClassName,
  clickPrev,
  clickNext,
  selectedIndex,
  scrollSnaps,
  scrollTo,
  selectedDotColor,
}: {
  navigationButtonClassName: string;
  clickPrev: () => void;
  clickNext: () => void;
  selectedIndex: number;
  scrollSnaps: number[];
  scrollTo: (i: number) => void;
  /** When set, used as background for the active dot instead of theme secondary. */
  selectedDotColor?: string;
}) => {
  return (
    <div
      className={cn(
        "flex justify-center gap-2 mt-4",
        navigationButtonClassName
      )}
    >
      {scrollSnaps.map((_, i) => (
        <button
          key={i}
          type="button"
          aria-label={`Carousel slide ${i + 1}`}
          aria-current={i === selectedIndex ? "true" : undefined}
          onClick={() => scrollTo(i)}
          className={cn(
            "h-3 rounded-full transition-all cursor-pointer",
            i === selectedIndex
              ? cn(
                  "w-[26px] scale-110",
                  !selectedDotColor && "bg-secondary-main"
                )
              : "w-3 bg-gray-300"
          )}
          style={
            i === selectedIndex && selectedDotColor
              ? { backgroundColor: selectedDotColor }
              : undefined
          }
        />
      ))}
    </div>
  );
};

export default DotButtons;
